$(document).ready(function() {
    var currentIndex = 0;
    var totalButtons = $('.thumbnail-list .thumbnail').length;
    
    $(".media--icon--right").click(function() {
        $('.slider-button--next').click();
        
        if (currentIndex < totalButtons - 1) {
            currentIndex++;
        } else {
            currentIndex = 0; // Reset index to 0 when at the last index
        }
        
        clickThumbnail(currentIndex);
    });
    
    $(".media--icon--left").click(function() {
        $('.slider-button--prev').click();
        
        if (currentIndex > 0) {
            currentIndex--;
        } else {
            currentIndex = totalButtons - 1; // Set index to last index when at 0
        }
        
        clickThumbnail(currentIndex);
    });
    
    function clickThumbnail(index) {
        var $thumbnailList = $('.thumbnail-list');
        var $buttons = $thumbnailList.find('.thumbnail');
        
        $buttons.eq(index).click();
    }

  $('.product-form__input--dropdown select').on('change', function() {
        // Get the selected option value
        var selectedValue = $(this).val();
        
        // Find the closest .slc-value and update its text
        $(this).closest('.product-form__input--dropdown').find('.slc-value').text(selectedValue);
    });

   // Event listener for click on .v-swatch elements
    $('.v-swatch').on('click', function() {
        var dataNameValue = $(this).attr('data-name');
      $(this).addClass('sw-active');
      $(this).siblings().removeClass('sw-active');
        $(this).siblings('.form__label').find('.slc-value').text(dataNameValue);
    });
});
